import moment from "moment";
import React from "react";
import { AlertItem } from "../alertsMockData";

interface Props {
  alert: AlertItem;
  actionLabel: "Unsnooze" | "Undismiss";
  onAction: () => void;
  isLoading?: boolean;
}

// Read-only card for the Snoozed/Dismissed lists (AlertsPage.tsx) - unlike AlertCard.tsx (the
// active-alerts list), there's no Open/Snooze/Dismiss here, just the one action that restores the
// alert to the main list.
export const AlertHistoryCard = (props: Props) => {
  const { alert, actionLabel, onAction, isLoading } = props;

  return (
    <div className={`alert_card alert_card--${alert.severity}`} data-test-id={`alert-history-card-${alert.alert_id}`}>
      <h3 className="alert_card_title">{alert.title}</h3>
      <p className="alert_card_triggered">Triggered: {moment(alert.triggered_at).format("MMMM D, YYYY")}</p>
      {/* Only ever set on the Snoozed list (AlertItem's own comment) - the Dismissed list has
          nothing further to say about timing, dismissal doesn't expire on its own. */}
      {alert.snoozed_until && <p className="alert_card_triggered">Snoozed until: {moment(alert.snoozed_until).format("MMMM D, YYYY")}</p>}
      <p className="alert_card_message">{alert.message}</p>
      <div className="alert_card_actions">
        <button
          className="alert_card_open"
          onClick={onAction}
          disabled={isLoading}
          data-test-id={`alert-history-card-action-${alert.alert_id}`}
        >
          {actionLabel}
        </button>
      </div>
    </div>
  );
};
